import EditActComponent from "components/Project/Overview/Actas/createAct/EditActComponent"
import React from "react"
import { Helmet } from "react-helmet-async"
import { Container } from "reactstrap"

const NewEditAct = () => {
  return (
    <React.Fragment>
      <div className="page-content" style={{ overflow: "hidden" }}>
        <Helmet>
          <title>Planhopper | Actas</title>
        </Helmet>
        <Container fluid>
          <EditActComponent />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default NewEditAct
